type Props = {}

const AuthenticationModalSignupComponent = (props: Props) => {
  return <></>
}

export default AuthenticationModalSignupComponent
